import React from "react";
import MessageInput from "../../components/MessageInput/MessageInput";
import BenchmarkingChatWindow from "../../components/BenchmarkingChatWindow/BenchmarkingChatWindow";

const Benchmarking: React.FC = () => {

    return (
        <div className="benchmarkingChatWindow">
            <BenchmarkingChatWindow />
            <MessageInput isIDMUpload={false} currentModule='benchmarking' />
        </div>

    )
}

export default Benchmarking